export enum OperatorType {
    OPERATOR = "OPERATOR",
    MANAGER = "MANAGER",
    ADMIN = "ADMIN",
}